import ApiService from './ApiService';
import UtilsService from './UtilsService';
import UserQueries from '../queries/user.queries';
import store from '@/store';

function getAllUsers() {
  const retailerId = store.state.auth.currentUser.retailer.objectId;
  const query = UserQueries.getAll(retailerId);
  const path = UtilsService.buildFullPath(query);
  return ApiService.get(path).then((res) => res.results);
}

const UserService = {
  getAllUsers,
};

export default UserService;
